import React from 'react';

const MarkdownViewer = ({markdown}) => {
    const parseContent = (text) => {
        const tableRegex = /(<table[^>]*>[\s\S]*?<\/table>)/gim;
        const figureRegex = /<figure.*?>\s*([\s\S]*?)\s*<\/figure>/gim;
        const content = text.replace(figureRegex, '$1')
        const parts = content.split(tableRegex);
        return parts.filter(part => part.trim()).map(part => {
            if (part.match(tableRegex)) {
                return tableToHtml(part)
            }
            return markdownToHtml(part)
        })
    };

    const markdownToHtml = (markdown) => {
        let html = markdown
            /** Server sent tags **/
            // p
            .replace(/<p.*?>\s*([\s\S]*?)\s*<\/p>/gim, '$1')
            // br
            .replace(/<br\s*\/?>/gim, '\n')
            /** Server sent tags **/

            // tags as-is
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            // Headers
            .replace(/^##### (.*$)/gim, '<h5 class="text-sm font-semibold mt-4 mb-2">$1</h5>')
            .replace(/^#### (.*$)/gim, '<h4 class="text-md font-semibold mt-4 mb-2">$1</h4>')
            .replace(/^### (.*$)/gim, '<h3 class="text-lg font-semibold mt-4 mb-2">$1</h3>')
            .replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold mt-6 mb-3">$1</h2>')
            .replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold mt-8 mb-4">$1</h1>')
            // Bold
            .replace(/\*\*(.*)\*\*/gim, '<strong class="font-bold">$1</strong>')
            // Italic
            .replace(/\*(.*)\*/gim, '<em class="italic">$1</em>')
            // Code inline
            .replace(/`([^`]*)`/gim, '<code class="bg-gray-100 px-1 py-0.5 rounded text-sm font-mono">$1</code>')
            // Links
            .replace(/\[([^\]]*)]\(([^)]*)\)/gim, '<a href="$2" class="text-blue-600 hover:text-blue-800 underline" target="_blank" rel="noopener noreferrer">$1</a>')
            // Line breaks
            .replace(/\n\n/gim, '</p><p class="mb-4">')
            // Single line breaks
            .replace(/\n/gim, '<br>')
            // Handle lists
            .replace(/^\* (.*)$/gim, '<li class="ml-4">• $1</li>')
            .replace(/^(\d+)\. (.*)$/gim, '<li class="ml-4">$1. $2</li>')
            // Handle page marker
            .replace(/\[(Page: \d+)]/gim, '<h3 class="text-lg font-semibold">$1</h3>')

        // Wrap in paragraph if not already wrapped
        if (!html.startsWith('<h') && !html.startsWith('<p') && !html.startsWith('<li')) {
            html = `<p class="mb-2">${html}</p>`;
        }

        return html;
    };
    const tableToHtml = (table) => {
        return table
            .replace(/<table[^>]*>/gi, '<table class="w-full border-collapse border my-4 text-sm">')
            .replace(/<th([^>]*)>/gi, '<th$1 class="bg-gray-50 p-3 text-left font-semibold border border-gray-300">')
            .replace(/<td([^>]*)>/gi, '<td$1 class="p-3 border border-gray-300">')
            .replace(/<tr([^>]*)>/gi, '<tr$1 class="even:bg-gray-50 hover:bg-gray-100">');
    }

    return <div className="p-4">
        {parseContent(markdown).map((part, index) => {
            return <div key={index}
                        className={`w-full rounded text-nowrap overflow-x-auto`}
                        dangerouslySetInnerHTML={{__html: part}}/>
        })}
    </div>
};

export default MarkdownViewer;
